export const buildSections = (sectionDefs) =>
  sectionDefs
    .map(({ label, items }) => ({ label, items: items.filter(Boolean) }))
    .filter((section) => section.items.length > 0);

export const buildMenu = ({ menuName, route, icon, sectionDefs, options }) => {
  const sections = buildSections(sectionDefs);
  return sections.length > 0 ? { menuName, route, icon, sections, options } : null;
};

export const SECTION_LABELS = {
  OPPORTUNITIES: "SUPORTE À DECISÃO",
  TRANSACTIONAL: "TRANSACIONAL",
  DATA: "Dados",
};